export default __webpack_public_path__ + "static/media/History.10b2eece.svg";